import { render, staticRenderFns } from "./TabBusinessTermDatasource.vue?vue&type=template&id=353ca18e&scoped=true&lang=pug"
import script from "./TabBusinessTermDatasource.vue?vue&type=script&lang=js"
export * from "./TabBusinessTermDatasource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353ca18e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('353ca18e')) {
      api.createRecord('353ca18e', component.options)
    } else {
      api.reload('353ca18e', component.options)
    }
    module.hot.accept("./TabBusinessTermDatasource.vue?vue&type=template&id=353ca18e&scoped=true&lang=pug", function () {
      api.rerender('353ca18e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tableau/datasource/TabBusinessTermDatasource.vue"
export default component.exports